(function () {
  const STORAGE_KEY = 'fp2_warranty_upsell_declined';
  const SKIPPED_GROUPS_KEY = 'fp2_warranty_upsell_skipped_groups';
  const PROP_GROUP = '_wup_group';
  const PROP_ROLE = '_wup_role';
  const PROP_STATUS = '_wup_status';
  const PROP_WARRANTY_VARIANT = '_wup_warranty_variant';
  const CHECK_ICON =
    '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10.8984 3.77348L4.89844 9.77348C4.84618 9.82592 4.78408 9.86752 4.71571 9.89591C4.64734 9.9243 4.57403 9.93892 4.5 9.93892C4.42597 9.93892 4.35266 9.9243 4.28429 9.89591C4.21592 9.86752 4.15382 9.82592 4.10156 9.77348L1.47656 7.14848C1.42424 7.09615 1.38273 7.03404 1.35442 6.96567C1.3261 6.89731 1.31152 6.82404 1.31152 6.75004C1.31152 6.67604 1.3261 6.60277 1.35442 6.53441C1.38273 6.46604 1.42424 6.40392 1.47656 6.3516C1.52889 6.29928 1.591 6.25777 1.65937 6.22945C1.72773 6.20114 1.801 6.18656 1.875 6.18656C1.949 6.18656 2.02227 6.20114 2.09063 6.22945C2.159 6.25777 2.22111 6.29928 2.27344 6.3516L4.50047 8.57863L10.1025 2.97754C10.2082 2.87187 10.3515 2.8125 10.5009 2.8125C10.6504 2.8125 10.7937 2.87187 10.8994 2.97754C11.005 3.08321 11.0644 3.22653 11.0644 3.37598C11.0644 3.52542 11.005 3.66874 10.8994 3.77441L10.8984 3.77348Z" fill="#089669"/></svg>';

  function getRoot() {
    return document.getElementById('WarrantyUpsellPopup');
  }

  function isEnabled() {
    const root = getRoot();
    return !!(root && root.dataset.enabled === 'true');
  }

  function getShowOn() {
    const root = getRoot();
    const value = root?.dataset?.showOn || 'both';
    if (value === 'atc' || value === 'checkout' || value === 'both') return value;
    return 'both';
  }

  function shouldShowOnAtc() {
    const value = getShowOn();
    return value === 'atc' || value === 'both';
  }

  function shouldShowOnCheckout() {
    const value = getShowOn();
    return value === 'checkout' || value === 'both';
  }

  function createGroupId() {
    return `wup_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
  }

  function getItemProps(item) {
    return item?.properties || {};
  }

  function getMoneyFormat() {
    const root = getRoot();
    const fromPopup = root?.getAttribute('data-money-format');
    if (fromPopup) return fromPopup;
    const fromFp2 = document.querySelector('.featured-product2-container')?.getAttribute('data-money-format');
    return fromFp2 || '${{amount}}';
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) return '0';

    const value = (Math.abs(number) / 100).toFixed(precision);
    const parts = value.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    const centsPart = parts[1] ? decimal + parts[1] : '';
    return dollars + centsPart;
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = getMoneyFormat();
    const match = formatString.match(placeholderRegex);
    if (!match) return String(cents / 100);

    let value;
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  /** Recalculate popup price texts from unit cents × qty. */
  function applyQtyPricing(payload, qty) {
    if (!payload) return payload;
    const safeQty = Math.max(1, parseInt(qty, 10) || 1);
    payload.qty = safeQty;

    const unitCents = parseInt(payload.priceCents, 10) || 0;
    const displayUnit =
      payload.displayPriceCents != null && payload.displayPriceCents !== ''
        ? parseInt(payload.displayPriceCents, 10) || unitCents
        : unitCents;

    if (displayUnit > 0 || unitCents > 0) {
      payload.priceText = formatMoney(displayUnit * safeQty);
      if (unitCents > displayUnit) {
        payload.compareText = formatMoney(unitCents * safeQty);
      } else {
        payload.compareText = '';
      }
    }

    return payload;
  }

  function collectFromBlock(block, qty) {
    if (!block) return null;
    const variantId = block.dataset.warrantyVariantId || block.getAttribute('data-warranty-variant-id');
    if (!variantId) return null;

    const safeQty = Math.max(1, parseInt(qty, 10) || 1);
    const badges = [
      block.getAttribute('data-warranty-badge-1'),
      block.getAttribute('data-warranty-badge-2'),
      block.getAttribute('data-warranty-badge-3'),
    ].filter(Boolean);

    const priceCents = parseInt(block.getAttribute('data-warranty-price') || '0', 10) || 0;
    const displayPriceCents = parseInt(
      block.getAttribute('data-warranty-display-price') || String(priceCents),
      10
    ) || priceCents;

    const payload = {
      variantId: String(variantId),
      qty: safeQty,
      title: block.getAttribute('data-warranty-title') || '',
      subtitle: block.getAttribute('data-warranty-subtitle') || '',
      description: block.getAttribute('data-warranty-description') || '',
      badges,
      acceptLabel: block.getAttribute('data-warranty-accept-label') || 'Add to order',
      declineLabel: block.getAttribute('data-warranty-decline-label') || 'No thanks',
      image: block.getAttribute('data-warranty-image') || '',
      priceCents,
      displayPriceCents,
      priceText: '',
      compareText: '',
    };

    return applyQtyPricing(payload, safeQty);
  }

  /**
   * Attach FP2 warranty-linking properties to /cart/add.js items.
   * Products and warranty from the same add share _wup_group.
   */
  function buildCartItemsWithWarrantyProps(selections, options = {}) {
    const {
      groupId = createGroupId(),
      protected: isProtected = false,
      warrantyVariantId = null,
      warrantyQty = 0,
    } = options;

    const items = (selections || []).map((item) => {
      const props = {
        ...(item.properties || {}),
        [PROP_GROUP]: groupId,
        [PROP_ROLE]: 'product',
        [PROP_STATUS]: isProtected ? 'protected' : 'unprotected',
      };
      if (warrantyVariantId) {
        props[PROP_WARRANTY_VARIANT] = String(warrantyVariantId);
      }
      return {
        id: item.id,
        quantity: item.quantity,
        properties: props,
      };
    });

    if (isProtected && warrantyVariantId && warrantyQty > 0) {
      items.push({
        id: warrantyVariantId,
        quantity: warrantyQty,
        properties: {
          [PROP_GROUP]: groupId,
          [PROP_ROLE]: 'warranty',
        },
      });
    }

    return { items, groupId };
  }

  function saveDeclined(payload) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      /* ignore */
    }
  }

  function clearDeclined() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function getSkippedGroups() {
    try {
      const raw = sessionStorage.getItem(SKIPPED_GROUPS_KEY);
      if (!raw) return [];
      const data = JSON.parse(raw);
      return Array.isArray(data) ? data.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function markGroupsSkipped(groupIds) {
    try {
      const set = new Set(getSkippedGroups());
      (groupIds || []).forEach((id) => {
        if (id) set.add(String(id));
      });
      sessionStorage.setItem(SKIPPED_GROUPS_KEY, JSON.stringify([...set]));
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function clearSkippedGroups(groupIds) {
    try {
      if (!groupIds?.length) {
        sessionStorage.removeItem(SKIPPED_GROUPS_KEY);
        return;
      }
      const remove = new Set(groupIds.map(String));
      const next = getSkippedGroups().filter((id) => !remove.has(String(id)));
      if (next.length) {
        sessionStorage.setItem(SKIPPED_GROUPS_KEY, JSON.stringify(next));
      } else {
        sessionStorage.removeItem(SKIPPED_GROUPS_KEY);
      }
    } catch (e) {
      /* ignore */
    }
  }

  function markSkipped() {
    markGroupsSkipped(['__all__']);
  }

  function wasSkipped() {
    return getSkippedGroups().includes('__all__');
  }

  function getDeclined() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data?.variantId) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function fill(payload) {
    const root = getRoot();
    if (!root || !payload) return;

    const titleEl = root.querySelector('[data-wup-title]');
    const subtitleEl = root.querySelector('[data-wup-subtitle]');
    const descEl = root.querySelector('[data-wup-description]');
    const badgesEl = root.querySelector('[data-wup-badges]');
    const priceEl = root.querySelector('[data-wup-price]');
    const compareEl = root.querySelector('[data-wup-compare-price]');
    const imageEl = root.querySelector('[data-wup-image]');
    const iconFallback = root.querySelector('[data-wup-icon-fallback]');
    const acceptBtn = root.querySelector('[data-wup-accept]');
    const declineBtn = root.querySelector('[data-wup-decline-btn]');

    if (titleEl) titleEl.textContent = payload.title || '';

    if (subtitleEl) {
      if (payload.subtitle) {
        subtitleEl.textContent = payload.subtitle;
        subtitleEl.hidden = false;
      } else {
        subtitleEl.textContent = '';
        subtitleEl.hidden = true;
      }
    }

    if (descEl) {
      if (payload.description) {
        descEl.textContent = payload.description;
        descEl.hidden = false;
      } else {
        descEl.textContent = '';
        descEl.hidden = true;
      }
    }

    if (badgesEl) {
      badgesEl.innerHTML = '';
      const badges = Array.isArray(payload.badges) ? payload.badges.filter(Boolean) : [];
      if (badges.length) {
        badges.forEach((text) => {
          const li = document.createElement('li');
          li.className = 'wup__badge';
          li.innerHTML = CHECK_ICON + text;
          badgesEl.appendChild(li);
        });
        badgesEl.hidden = false;
      } else {
        badgesEl.hidden = true;
      }
    }

    if (priceEl) {
      const prefix = payload.priceText && !String(payload.priceText).startsWith('+') ? '+' : '';
      priceEl.textContent = payload.priceText ? prefix + payload.priceText : '';
    }

    if (compareEl) {
      if (payload.compareText) {
        compareEl.textContent = payload.compareText;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }

    if (imageEl && iconFallback) {
      if (payload.image) {
        imageEl.src = payload.image;
        imageEl.alt = payload.title || '';
        imageEl.hidden = false;
        iconFallback.hidden = true;
      } else {
        imageEl.removeAttribute('src');
        imageEl.hidden = true;
        iconFallback.hidden = false;
      }
    }

    if (acceptBtn) acceptBtn.textContent = payload.acceptLabel || 'Add to order';
    if (declineBtn) declineBtn.textContent = payload.declineLabel || 'No thanks';
  }

  let activeResolver = null;
  let bound = false;
  let isAnimating = false;
  const ANIM_MS = 380;

  function setLoading(isLoading) {
    const root = getRoot();
    if (!root) return;
    root.querySelectorAll('.wup__btn').forEach((btn) => {
      btn.disabled = !!isLoading;
    });
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function openAnimated() {
    const root = getRoot();
    if (!root) return;

    root.hidden = false;
    root.classList.remove('is-closing');
    document.documentElement.classList.add('wup-open');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        root.classList.add('is-open');
      });
    });
  }

  function closeAnimated() {
    const root = getRoot();
    if (!root) return Promise.resolve();

    setLoading(false);

    if (root.hidden || !root.classList.contains('is-open')) {
      root.classList.remove('is-open', 'is-closing');
      root.hidden = true;
      document.documentElement.classList.remove('wup-open');
      return Promise.resolve();
    }

    if (prefersReducedMotion()) {
      root.classList.remove('is-open', 'is-closing');
      root.hidden = true;
      document.documentElement.classList.remove('wup-open');
      return Promise.resolve();
    }

    return new Promise((done) => {
      isAnimating = true;
      root.classList.remove('is-open');
      root.classList.add('is-closing');

      const dialog = root.querySelector('.wup__dialog');
      let finished = false;

      const finish = () => {
        if (finished) return;
        finished = true;
        isAnimating = false;
        root.classList.remove('is-closing');
        root.hidden = true;
        document.documentElement.classList.remove('wup-open');
        done();
      };

      const onEnd = (e) => {
        if (!dialog || e.target !== dialog) return;
        dialog.removeEventListener('transitionend', onEnd);
        finish();
      };

      if (dialog) {
        dialog.addEventListener('transitionend', onEnd);
      }
      setTimeout(finish, ANIM_MS);
    });
  }

  async function resolve(choice) {
    if (isAnimating) return;
    const resolver = activeResolver;
    activeResolver = null;
    await closeAnimated();
    if (typeof resolver === 'function') resolver(choice);
  }

  function bindOnce() {
    if (bound) return;
    const root = getRoot();
    if (!root) return;
    bound = true;

    root.querySelectorAll('[data-wup-decline], [data-wup-decline-btn]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        resolve('decline');
      });
    });

    const acceptBtn = root.querySelector('[data-wup-accept]');
    if (acceptBtn) {
      acceptBtn.addEventListener('click', (e) => {
        e.preventDefault();
        resolve('accept');
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root && !root.hidden && root.classList.contains('is-open')) {
        resolve('decline');
      }
    });
  }

  function prompt(payload) {
    return new Promise((resolveChoice) => {
      const root = getRoot();
      if (!root || !payload?.variantId) {
        resolveChoice('decline');
        return;
      }

      bindOnce();
      if (activeResolver) {
        const prev = activeResolver;
        activeResolver = null;
        prev('decline');
      }
      activeResolver = resolveChoice;
      fill(payload);
      openAnimated();
    });
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  /**
   * Latest product group that has no matching warranty line in cart.
   * Only the most recently added unprotected group is offered at checkout
   * (not the sum of every unprotected line).
   * Covers: declined at ATC (unprotected) AND warranty removed manually
   * after a protected add (status still "protected", but warranty line gone).
   * Old cart lines without _wup_* props are ignored.
   */
  function findUnprotectedNeeds(cart) {
    const skipped = new Set(getSkippedGroups());
    if (skipped.has('__all__')) {
      return { needQty: 0, groups: [], warrantyVariantId: null };
    }

    const items = cart?.items || [];
    const coveredGroups = new Set();

    items.forEach((item) => {
      const props = getItemProps(item);
      if (props[PROP_ROLE] === 'warranty' && props[PROP_GROUP]) {
        coveredGroups.add(String(props[PROP_GROUP]));
      }
    });

    const groupsMap = new Map();

    items.forEach((item) => {
      const props = getItemProps(item);
      if (props[PROP_ROLE] !== 'product') return;

      const group = props[PROP_GROUP] ? String(props[PROP_GROUP]) : null;
      if (!group || coveredGroups.has(group) || skipped.has(group)) return;

      const qty = parseInt(item.quantity, 10) || 0;
      if (qty <= 0) return;

      const existing = groupsMap.get(group) || {
        group,
        qty: 0,
        warrantyVariantId: null,
      };
      existing.qty += qty;
      if (!existing.warrantyVariantId && props[PROP_WARRANTY_VARIANT]) {
        existing.warrantyVariantId = String(props[PROP_WARRANTY_VARIANT]);
      }
      groupsMap.set(group, existing);
    });

    if (!groupsMap.size) {
      return { needQty: 0, groups: [], warrantyVariantId: null };
    }

    // Cart items are most-recently-added first — use that group only.
    let latest = null;
    for (let i = 0; i < items.length; i++) {
      const props = getItemProps(items[i]);
      if (props[PROP_ROLE] !== 'product') continue;
      const group = props[PROP_GROUP] ? String(props[PROP_GROUP]) : null;
      if (!group || !groupsMap.has(group)) continue;
      latest = groupsMap.get(group);
      break;
    }

    if (!latest) {
      return { needQty: 0, groups: [], warrantyVariantId: null };
    }

    return {
      needQty: latest.qty,
      groups: [{ group: latest.group, qty: latest.qty }],
      warrantyVariantId: latest.warrantyVariantId,
    };
  }

  async function buildCheckoutOffer() {
    const cart = await fetchCart();
    const needs = findUnprotectedNeeds(cart);
    if (!needs.needQty) return null;

    const block = document.querySelector('.fp2-warranty-upsell');
    let payload = getDeclined();

    if (block) {
      const fromBlock = collectFromBlock(block, needs.needQty);
      if (fromBlock) {
        payload = { ...(payload || {}), ...fromBlock };
      }
    }

    if (!payload?.variantId && needs.warrantyVariantId) {
      payload = {
        ...(payload || {}),
        variantId: needs.warrantyVariantId,
        title: (payload && payload.title) || 'Complete Protection',
        acceptLabel: (payload && payload.acceptLabel) || 'Add to order',
        declineLabel: (payload && payload.declineLabel) || 'No thanks',
        badges: (payload && payload.badges) || [],
        priceText: (payload && payload.priceText) || '',
        compareText: (payload && payload.compareText) || '',
        image: (payload && payload.image) || '',
      };
    }

    if (!payload?.variantId) return null;

    payload.uncoveredGroups = needs.groups;
    applyQtyPricing(payload, needs.needQty);
    return payload;
  }

  async function addWarrantyToCart(payload) {
    if (!payload?.variantId) return false;

    const groups = Array.isArray(payload.uncoveredGroups) ? payload.uncoveredGroups : null;
    let items;

    if (groups?.length) {
      items = groups.map((g) => ({
        id: Number(payload.variantId),
        quantity: Math.max(1, parseInt(g.qty, 10) || 1),
        properties: {
          [PROP_GROUP]: String(g.group),
          [PROP_ROLE]: 'warranty',
        },
      }));
    } else {
      const qty = Math.max(1, parseInt(payload.qty, 10) || 1);
      const groupId = payload.groupId || createGroupId();
      items = [
        {
          id: Number(payload.variantId),
          quantity: qty,
          properties: {
            [PROP_GROUP]: groupId,
            [PROP_ROLE]: 'warranty',
          },
        },
      ];
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) throw new Error('Failed to add warranty');
    if (typeof window.refreshedCartDrawer === 'function') {
      await window.refreshedCartDrawer();
    }
    return true;
  }

  async function handleCheckoutIntercept(event) {
    if (!isEnabled()) return false;
    if (!shouldShowOnCheckout()) return false;
    if (wasSkipped()) return false;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    let payload = null;
    try {
      payload = await buildCheckoutOffer();
    } catch (err) {
      console.error(err);
      window.location.href = '/checkout';
      return true;
    }

    if (!payload) {
      clearDeclined();
      window.location.href = '/checkout';
      return true;
    }

    const choice = await prompt(payload);
    const groupIds = (payload.uncoveredGroups || []).map((g) => g.group);

    if (choice === 'accept') {
      try {
        setLoading(true);
        await addWarrantyToCart(payload);
        clearDeclined();
        clearSkippedGroups(groupIds);
        window.location.href = '/checkout';
      } catch (err) {
        console.error(err);
        setLoading(false);
        markGroupsSkipped(groupIds);
        window.location.href = '/checkout';
      }
    } else {
      markGroupsSkipped(groupIds);
      window.location.href = '/checkout';
    }

    return true;
  }

  function bindCheckoutButtons() {
    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"], input[name="checkout"]');
        if (!btn) return;
        handleCheckoutIntercept(e);
      },
      true
    );
  }

  window.WarrantyUpsellPopup = {
    isEnabled,
    getShowOn,
    shouldShowOnAtc,
    shouldShowOnCheckout,
    collectFromBlock,
    createGroupId,
    buildCartItemsWithWarrantyProps,
    prompt,
    saveDeclined,
    clearDeclined,
    markSkipped,
    markGroupsSkipped,
    clearSkippedGroups,
    wasSkipped,
    getDeclined,
    findUnprotectedNeeds,
    buildCheckoutOffer,
    addWarrantyToCart,
    setLoading,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCheckoutButtons);
  } else {
    bindCheckoutButtons();
  }
})();
